import { render } from "./9_inPie.vue?vue&type=template&id=aa51d906&scoped=true"
import script from "./9_inPie.vue?vue&type=script&lang=js"
export * from "./9_inPie.vue?vue&type=script&lang=js"

import "./9_inPie.vue?vue&type=style&index=0&id=aa51d906&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa51d906"]])

export default __exports__